<template>
  <footer class="site-footer">
    <div class="container footer-main">
      <div class="footer-brand">
        <router-link to="/" class="brand footer-logo">
          <span class="brand-mark"><span></span><span></span><span></span></span>
          <span class="brand-copy">
          <strong>ASSFOS</strong>
          <small>SERVICES LTD</small>
        </span>
          <!-- <span class="brand-copy"><strong>VOLTEDGE</strong><small>SYSTEMS & ENGINEERING</small></span> -->
        </router-link>
        <p>Integrated engineering systems that keep facilities powered, protected and connected.</p>
        <div class="footer-location">Port Harcourt, Rivers State · Nigeria</div>
      </div>

      <div>
        <h4>Solutions</h4>
        <router-link to="/services#power">Power Backup</router-link>
        <router-link to="/services#fire">Fire Protection</router-link>
        <router-link to="/services#communication">Communication</router-link>
        <router-link to="/services#security">Security Systems</router-link>
        <router-link to="/services#networking">IT Networking</router-link>
      </div>

      <div>
        <h4>Company</h4>
        <router-link to="/about">About Us</router-link>
        <router-link to="/projects">Projects</router-link>
        <router-link to="/contact">Contact</router-link>
      </div>

      <div class="footer-contact">
        <h4>Start a project</h4>
        <p>Tell us about your facility and what you need to achieve.</p>
        <router-link class="footer-link" to="/contact">Request a consultation <span>→</span></router-link>
      </div>
    </div>
    <div class="container footer-bottom">
      <span>© {{ year }} VoltEdge Systems & Engineering. All rights reserved.</span>
      <span>Power · Protection · Connection</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>